import styled from "styled-components";

/* ===== HEADER ===== */
export const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 3px 80px 0px;
  @media (max-width: 1400px) {
    padding: 3px 10px 0px;
}
`;

/* ===== NAV BAR ===== */
export const NavBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 60px;

  @media (min-width: 1401px) and (max-width: 1523px) {
    padding: 2px 16px;
  }

  @media (max-width: 1400px) {
    padding: 4px 12px;
    display: flex;
  }

  @media (max-width: 368px) {
    padding: 2px 6px;
  }
`;

/* ===== LOGO ===== */
export const Logo = styled.div`
  img {
    height: 55px;

    @media (max-width: 368px) {
      height: 38px;
    }
  }
`;

/* ===== HAMBURGER ===== */
export const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;

  span {
    width: 30px;
    height: 4px;
    background: #171f32;
    border-radius: 2px;
  }

  @media (max-width: 1400px) {
    display: flex;
    padding-right: 10px;
  }
`;


/* ===== MENU ===== */
export const Menu = styled.nav`
  flex: 1;
  display: flex;
  justify-content: center;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  > ul {
    display: flex;
    gap: 28px;
    align-items: center;

    @media (min-width: 1636px) and (max-width: 1750px) {
      gap: 18px;
    }

    @media (min-width: 1524px) and (max-width: 1635px) {
      gap: 12px;
    }

    @media (min-width: 1401px) and (max-width: 1523px) {
      gap: 14px;
    }
  }

  li {
    position: relative;
  }

a,span {
  text-decoration: none;
  color: #171f32;
  font-weight: 600;
  cursor: pointer;

  @media (min-width: 1636px) and (max-width: 1750px) {
    font-size: 13px;
  }

  @media (min-width: 1524px) and (max-width: 1635px) {
    font-size: 11px;
  }

  @media (min-width: 1401px) and (max-width: 1523px) {
    font-size: 12px;
  }
}

  /* ===== MOBILE ===== */
  @media (max-width: 1400px) {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    display: ${({ open }) => (open ? "block" : "none")};

    > ul {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 30px;
      gap: 18px;
    }

    @media (max-width: 368px) {
      > ul {
        padding: 14px 16px;
        gap: 14px;
        font-size: 13px;
      }
    }
  }
`;

/* ===== DROPDOWN ===== */
export const Dropdown = styled.ul`
  background: #fff;
  list-style: none;
  padding-left: 20px;
  margin-top: 10px;

  display: ${({ open }) => (open ? "block" : "none")};

  li {
    padding: 8px 10px;
    font-size: 14px;

    @media (max-width: 1400px) {
      font-size: 13px;
    }

    /* 🔥 Hover effect */
    &:hover {
      background-color: #0f172a;
    }

    &:hover a {
      color: #ffffff;
    }
  }

  /* Desktop */
  @media (min-width: 1401px) {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 230px;
    padding: 10px 0;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    display: none;
  }
`;


/* ===== MENU ITEM ===== */
export const MenuItem = styled.li`
  position: relative;

  /* Desktop hover */
  @media (min-width: 1401px) {
    &:hover > ${Dropdown} {
      display: block;
    }
  }
`;
/* ===== CTA ===== */
export const ActionButton = styled.a`
  padding: 10px 22px;
  background: #171f32;
  color: #fff;
  border-radius: 5px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #0f172a;
    background: #fff;
    border: 1px solid #0f172a;
  }

  @media (min-width: 1401px) and (max-width: 1523px) {
    padding: 8px 14px;
    font-size: 12px;
  }

  @media (max-width: 1400px) {
    display: inline-block;
    padding: 6px 16px;
  }

  @media (max-width: 368px) {
    padding: 4px 8px;
    font-size: 11px;
  }
`;

/* ===== ACTIVE LINK ===== */
export const NavLink = styled.a`
  color: ${({ active }) => (active ? "#00b4d8" : "#171f32")};
  border-bottom: ${({ active }) =>
    active ? "2px solid #791e1b" : "none"};
  padding-bottom: 4px;
`;


/* ===== DRILL DOWN ICON ===== */
export const DrillDown = styled.span`
  margin-left: 3px;
  font-size: 18px;
  transition: transform 0.3s ease;
  cursor: pointer;

  ${({ open }) =>
    open &&
    `
    transform: rotate(180deg);
  `}

  @media (max-width: 1400px) {
    font-size: 11px;
  }
`;

export const MobileOverlay = styled.div`
  display: none;

  @media (max-width: 1400px) {
    display: ${({ open }) => (open ? "block" : "none")};
    position: fixed;
    inset: 0;
    z-index: 9998;
    background: transparent;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  padding: 120px 30px 100px;
  max-width: 800px;
  height: 100vh;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: white;
  overflow-y: auto;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;

  width: 40px;
  height: 40px;

  border: none;
  background: #d6a54f;
  color: #fff;

  font-size: 22px;
  font-weight: bold;
  cursor: pointer;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
`;